/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Delete from './delete';
import Blocked from './blocked';
import Restore from './restore';
import dropdown from '../../../assets/images/dropdown.png';
import newStory from '../../../assets/images/new-story-icon.png';
import newFeature from '../../../assets/images/new-feature-icon.png';
import newCapability from '../../../assets/images/new-capability-icon.png';
import newEpic from '../../../assets/images/new-epic-icon.png';
import { filterAvailableOrgLevels } from '../../selectors/workPackageSelector';
import { updateWorkPackageLevel } from '../../actions/workPackageActions';
import { openModal } from '../../actions/modalActions';
import { currentOrganization } from '../../utils/organizationHelpers';

const Dropdown = (props) => {
  const [open, setOpen] = useState(false);

  const handleOrgLevelClick = async (orgLevel) => {
    props.changeOrgLevel(orgLevel);
  };
  let resultLevel1Default;
  if (props.type === 'Task') {
    resultLevel1Default = props.organizationLevels
      .sort((a, b) => a.level - b.level)
      .filter((level) => level.default_level)[0];
  }
  return (
    <div className={`dropdown btn-component-div ${open ? 'open' : ''}`}>
      <button
        id="detail-dropdown"
        type="button"
        className="btn btn-link"
        onClick={() => setOpen(!open)}
        disabled={!props.allowEdit}
      >
        <img src={dropdown} className="dropdown-btn" alt="dropdown button" />
      </button>
      <ul className="dropdown-menu">
        {props.type && props.type !== 'Task' && (
          <li onClick={props.handleRemove}>
            <a tabIndex={0} role="button">
              <span>Remove From Sprint</span>
            </a>
          </li>
        )}
        {props.handleBlock && (
          <li>
            <div
              tabIndex={0}
              role="button"
              onClick={() =>
                props.blocked
                  ? props.handleBlock(false)
                  : props.handleBlock(true)
              }
            >
              <Blocked />
              <span>
                {props.blocked ? 'Unblock' : 'Block'} {props.type}
              </span>
            </div>
          </li>
        )}
        {props.allowDelete && (
          <li>
            <div onClick={props.handleDelete}>
              <Delete />
              <span>
                {props.deleted ? 'Permanently Delete' : 'Delete'} {props.type}
              </span>
            </div>
          </li>
        )}
        {props.allowRestore && props.deleted && (
          <li>
            <div onClick={props.handleRestore}>
              <Restore />
              <span>Restore {props.type}</span>
            </div>
          </li>
        )}
        {props.dropdownType === 'Result' && (
          <li className="dropdown-changeto no-hover">
            <em>--- Change To ---</em>
          </li>
        )}
        {props.dropdownType === 'Result' &&
          props.organizationLevels
            .sort((a, b) => a.level - b.level)
            .map((orgLevel, index) => {
              let imgSource;
              if (orgLevel.level === 1) imgSource = newStory;
              if (orgLevel.level === 2) imgSource = newFeature;
              if (orgLevel.level === 3) imgSource = newCapability;
              if (orgLevel.level === 4) imgSource = newEpic;

              return (
                <li
                  key={`level-index-${index}`}
                  className={`result-level-drop level-${orgLevel.level}`}
                  onClick={() => handleOrgLevelClick(orgLevel)}
                >
                  <div className="level-icon-container">
                    <img src={imgSource} alt="" />
                  </div>
                  <div>
                    <span>{orgLevel.name}</span>
                  </div>
                </li>
              );
            })}
        {props.allowStartSprint && (
          <li>
            <div onClick={props.startSprint}>
              <span>Start Sprint</span>
            </div>
          </li>
        )}
        {props.allowEndSprint && (
          <li>
            <div onClick={props.endSprint}>
              <span>End Sprint</span>
            </div>
          </li>
        )}
        {props.type === 'Task' && (
          <li>
            <div onClick={props.changeToStory}>
              <span>{`Change to ${resultLevel1Default.name}`}</span>
            </div>
          </li>
        )}
      </ul>
    </div>
  );
};

Dropdown.propTypes = {
  handleRemove: PropTypes.func,
  handleBlock: PropTypes.func,
  handleDelete: PropTypes.func,
  startSprint: PropTypes.func,
  endSprint: PropTypes.func,
  type: PropTypes.string,
  blocked: PropTypes.bool,
  allowEdit: PropTypes.bool,
  allowDelete: PropTypes.bool,
  allowStartSprint: PropTypes.bool,
  allowEndSprint: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
  if (ownProps.dropdownType === 'Result') {
    return {
      organizationLevels: filterAvailableOrgLevels(state, ownProps)
    };
  }
  if (ownProps.type === 'Task') {
    const organizationLevels = currentOrganization()?.organization_levels || [];
    return {
      organizationLevels
    };
  }
  return {};
};

export default connect(mapStateToProps, { updateWorkPackageLevel, openModal })(
  Dropdown
);
